import BarChartComponent from '@/components/ui/charts/BarChartComponent';
import { useMemo } from 'react';

export type DailyConsultationsByStatusProps = {
    data: Array<{ status: string, count: number }>;
    title: string;
    date: string;
}

function DailyConsultationsByStatusComponent(props: DailyConsultationsByStatusProps) {
    const { data, title, date } = props;

    const transformedData = useMemo(() => data.map(item => ({
        label: item.status,
        values: [{ subLabel: date, value: item.count }]
    })), [data, date]);

    return <BarChartComponent data={transformedData} title={title} />;
}

export default DailyConsultationsByStatusComponent;
